import { BoxCollider } from "../Physics/BoxCollider";
import { ICollider } from "../Physics/ICollider";

export class CompoundBoxCollider implements ICollider {
    private _boxes: BoxCollider[];

    constructor(pBoxes: BoxCollider[]) {
        this._boxes = pBoxes;
    }

    public get boxes(): BoxCollider[] {
        return this._boxes;
    }
}
